<template>
<div class="bg-white">
<div class="container">
    <div class="row">
        <div class="col">
            <div>
                <h1 class="font-weight-bold mt-5 mb-5  headline-strong-1 text-blue">Datenschutz – einfach erklärt</h1>
                <p>
                    Wir geben Ihnen hier einen einfachen Überblick über den Schutz Ihrer Daten bei der GSI mbH. Vollständige Informationen zum Datenschutz finden Sie in unserer <a class="text-dark" href="/files/GSI_Datenschutzerklaerung.pdf"
                      target="_blank">Datenschutzerklärung</a>.
                </p>
                <br />
                <p>
                    Wir halten uns beim Datenschutz strickt an die Datenschutzgrundverordnung DSGVO und an das Bundesdatenschutzgesetz BDSG neu.
                </p>
                <br />
                <p>
                    Wir erfassen von Besuchern die IP Adresse oder den Domain Namen des Computers, mit
                    dem Sie unsere Website besuchen. Ebenso erfassen wir, welche Seiten Sie bei uns
                    aufrufen. Dies geschieht anonym und dient ausschließlich der Verbesserung unseres
                    Webauftritts.
                </p>
                <br />
                <p>
                    Wir verwenden Cookies, kleine Textdateien, die auf Ihrem Browser zwischengespeichert
                    werden. Dies können Sie abschalten, dann sind aber nicht mehr alle Funktionen unserer
                    Website gegeben.
                </p>
                <br />
                <p>
                    Mit Hilfe eines Trackingdienstes erstellen wir pseudonyme Nutzerprofile. Ein Rückschluss
                    auf Sie ist damit nicht möglich. Wenn Sie in Ihrem Browser die Cookies abgeschaltet haben
                    oder auf dem Browser gelöscht haben, werden diese Profile nicht angelegt oder
                    ausgewertet.
                </p>
                <br />
                <p>
                    Auf unseren Webseiten finden Sie Buttons von Sozial Media Netzwerken. Hierüber können
                    Sie z.B. Bekannten unseren Internetauftritt empfehlen. Wenn Sie auf einen solchen Button
                    klicken, können Daten von Ihnen an den Seitenbetreiber übermittelt werden.
                </p>
                <br />
                <p>
                    Die obigen Daten werden automatisch erhoben und dienen der Verbesserung unserer
                    Website und zum Vermeiden von Mißbrauch.
                </p>
                <br />
                <p>
                    Daten, die Sie auf unserer Website persönlich in ein Kontaktformular oder eine Anmeldung
                    für eine Veranstaltung eingeben, werden ausschließlich zu dem angegebenen Zweck
                    erhoben. Die Daten werden verschlüsselt übertragen.
                </p>
                <br />
                <p>
                    Als Websitebesucher haben Sie folgende Rechte:
                    <br />
                    <ul class="text-left" style="list-style:disc">
                        <li>
                            Sie können Auskunft über die von Ihnen gespeicherten Daten verlangen.
                        </li>
                        <li>
                            Sie können eine Löschung Ihrer Daten fordern.
                        </li>
                        <li>
                            Falsche Daten können Sie berichtigen lassen.
                        </li>
                        <li>
                            Sie können einen Widerspruch gegen die Nutzung Ihrer Daten einlegen.
                        </li>
                    </ul>
                    <br />
                    Bei Fragen wenden Sie sich bitte an unser Sekretariat oder unseren
                    Datenschutzbeauftragten.
                </p>
                <br />
                <p>
                    <span class="font-weight-bold">Kontaktdaten des Datenschutzbeauftragten:</span><br />
                    Bernhard Pickert-Goldenbogen<br />
                    E-Mail: <a class="text-dark" href="mailto:datenschutz@gsi-slv.de">datenschutz@gsi-slv.de</a><br /><br />
                    <span class="font-weight-bold">Kontakt der GSI mbH:</span><br />
                    GSI – Gesellschaft für Schweißtechnik International mbH<br />
                    Bismarckstr. 85<br />
                    47057 Duisburg<br />
                    E-Mail: <a class="text-dark" href="mailto:sekretariat@gsi-slv.de">sekretariat@gsi-slv.de</a><br /><br />
                    Hier geht es zu unserer ausführlichen <u><a class="text-dark" href="/files/GSI_Datenschutzerklaerung.pdf" target="_blank">Datenschutzerklärung</a></u>.
                </p>
            </div>
            <div>
                <div ref="cdt"></div>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<style lang="scss" scoped>
@import 'resources/sass/_variables.scss';

</style>

<script>
export default {
    mounted() {
        this.$nextTick(function () {
            if (this.$refs.cdt) {
                var cdtScript = document.createElement('script');
                cdtScript.id = 'CookieDeclaration';
                cdtScript.src = 'https://consent.cookiebot.com/240d25fa-5bf3-45be-9dd9-a74318930b77/cd.js';
                cdtScript.type = 'text/javascript';
                cdtScript.async = 'async';
                this.$refs.cdt.appendChild(cdtScript);
            }
        })
    }
}
</script>
